export default __webpack_public_path__ + "static/media/Transition_Start-Support.4fa9836b.mp4";